import { SNACKBAR } from "../Action";

export const ShowSnackbar = (data) => {
  return {
    type: SNACKBAR.snackBar,
    data: data,
  };
};
